import { parseQuery } from './utils.js';
// Google
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

// Set custom dimensions to track NXRM version
var params = parseQuery(window.location.search.substring(1));
var version_major = 'no-version';

if (params.version) {
  version_major = params.version.split(".")[0];
}

gtag('set', {
  'version_major' : version_major,
  'version'       : params.version,
  'usertype'      : params.usertype,
  'edition'       : params.edition,
  'variant'       : 'A'
});

// Nexus RM Analytics - GA4
gtag('config', 'G-0C4M1PWYZ7');
// Nexus Professional - GA4
gtag('config', 'G-T11SF3WXX2');
// Cross Domain
gtag('config', 'G-K2SPJK2C73');

// JQuery hooks
window.addEventListener('load', () => {
  var sys_err = $('#sys-error');
  if (sys_err.length > 0) {
    // If an error occurs, don't count it as a page view. Capture it as an error event.
    var sys_err_code = $('#sys-error #sys-error-code:first').text();
    var sys_err_msg  = $('#sys-error #sys-error-msg:first').text();

    gtag('event', 'exception', {
      'description' : sys_err_code + ' - ' + sys_err_msg,
      'fatal' : true
    });
  }
  else {
    gtag('event', 'screen_view', {
      'app_name' : 'outreach',
      'screen_name' : 'Splash-Page'
    });
  }

  // _trackOutbound
  $('a[href^="http"]:not([href*="//' + location.host + '"])').click(function(e) {
    gtag('event', 'click', {
      'event_category': 'outbound',
      'event_label': this.href,
      'transport_type': 'beacon'
    });
  });

  // _trackInline
  $('a[href^="#"]').click(function(e) {
    gtag('event', 'screen_view', {
      'app_name' : 'outreach',
      'screen_name' : this.href.split('#')[1]
    });
  });
});
